import { ReactNode } from 'react';
import Default from '@/layout/Default';

const Layout = ({ children, layout }: { children: ReactNode; layout: string | undefined }) => {
  switch (layout) {
    case 'empty':
      return <>{children}</>;
    default:
      return <Default>{children}</Default>;
  }
};

export default Layout;
